
        import { i18n } from './utils/I18n.js';
        document.addEventListener('DOMContentLoaded', () => {
            i18n.init();
            
            const trigger = document.getElementById('languageTrigger');
            const dropdown = document.getElementById('languageDropdown');
            const options = document.querySelectorAll('.lang-option');

            if (trigger && dropdown) {
                // 点击切换展开/收起
                trigger.onclick = (e) => {
                    e.stopPropagation();
                    const isOpen = dropdown.classList.toggle('show');
                    trigger.classList.toggle('open', isOpen);
                };

                // 点击选项切换语言
                options.forEach(opt => {
                    opt.onclick = () => {
                        const val = opt.dataset.value;
                        i18n.switchLanguage(val);
                        dropdown.classList.remove('show');
                        trigger.classList.remove('open');
                    };
                });

                // 点击外部关闭
                document.addEventListener('click', () => {
                    dropdown.classList.remove('show');
                    trigger.classList.remove('open');
                });
            }
        });
    